export default {
  home: {
    browseTopEvents: 'Diese Woche in Deiner Nähe',
    promotionEventsTitle: 'Top-Angebote heute',
    inspirationForYou: 'Verschenke Erlebnisgutscheine',
    kitsTitle: 'DIY-Boxen für zu Hause',
    recommendedForYou: 'Entdecke die beliebtesten Erlebnisse',
    newEventsForYou: 'Neue Kurse und Erlebnisse in Deiner Nähe',
    lastViewedEvents: 'Zuletzt angesehen',
    browseCategories: 'Entdecke Kurse nach Kategorie',
    header: {
      search: {
        selectCity: 'Stadt',
      },
    },
    headerButtonTitle: 'Event anfragen',
  },
}
